import camelCase from 'lodash/camelCase'
import upperFisrt from 'lodash/upperFirst'

const requireLang = require.context(
  './',
  true,
  /\.json$/
)

let msgs = {}

for (let file of requireLang.keys()) {
  if (file === './index.js') continue
  let path = file.replace(/(\.\/|\.json$)/g, '').split('/')

  path.reduce((acc, cur, index) => {
    let prop = upperFisrt(camelCase(cur))

    // when reach the deepest layer, assign i18n to the new object
    // otherwise create the empty object
    acc[prop] = index + 1 === path.length
      ? requireLang(file)
      : acc[prop] || {}
    return acc[prop]
  }, msgs)
}

export default msgs



// WEBPACK FOOTER //
// ./src/lang/en/index.js